<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <label><strong>เพิ่มงวดวันที่: </strong></label>
        <flat-pickr :config="{time_24hr: true, dateFormat: 'Y-m-d'}" v-model="drawdate" placeholder="เลือกวันที่" />
        <vs-button class="ml-2 mt-2" @click="addDrawdate" :disabled="isProcess">{{isProcess ? 'กำลังทำงาน...' : 'เพิ่มงวดหวย'}}</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import moment from '@/moment'

import LottoService from "@/services/lottoService"

export default {
  components: {
    flatPickr
  },
  data() {
    return {
      drawdate: moment().add(1, 'day').format("YYYY-MM-DD"),
      isProcess: false
    }
  },
  methods: {
    addDrawdate() {
      this.isProcess = true
      LottoService.addDrawdate(this.drawdate).then((response)=>{
        if(response.status === 'success') {
          this.$router.push({ name: 'admin-results', params: { resultDate: response.date } })
        }
      })
      .finally(()=>{
        this.isProcess = false
      })
    }
  }
}

</script>
